import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiStudioOrdersInit } from '@wix/da-papi-types';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { STUDIO_ORDERS_BY_DEVIATION_STREAM } from '../../../../constants';
import OriginalOrdersCard from '../OriginalOrdersCard';

import s from './OrdersByOriginalPageContent.scss';

const OrdersByOriginalPageContent: React.FC = () => {
  const { t } = useTranslation();
  const {
    items: orders,
    hasMore,
    fetchNext,
  } = useStream<PapiStudioOrdersInit['orders'][number]>(
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamId,
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamThrottle,
    STUDIO_ORDERS_BY_DEVIATION_STREAM.streamConfig
  );

  return (
    <div className={s['root']}>
      {orders.map((order, idx) => (
        <OriginalOrdersCard key={idx} order={order} />
      ))}
      {hasMore && (
        <div className={s['pagination']}>
          <TextButton variant="main" size="small" onClick={fetchNext}>
            {t('common.seeMore')}
          </TextButton>
        </div>
      )}
    </div>
  );
};
OrdersByOriginalPageContent.displayName = 'OrdersByOriginalPageContent';

export default OrdersByOriginalPageContent;
